/*
 * @Author: liuziwei
 * @Date: 2023-08-07 14:37:35
 * @LastEditTime: 2023-08-21 11:39:38
 * @LastEditors: liuziwei
 * @Description: 首页 - 天降弹窗 - 按钮
 * 睡觉了, 帮我关一下月亮 🌙  ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ
 */
<template minapp='mpx' xlang='wxml'>
  <!-- 领域展开 -->
  <view class="coupon-button-container" bindtap="clickBtn">
    <!-- 按钮  -->
    <view class="coupon-button" style="{{btnStyle}}">
      {{ BtnText }}
    </view>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'

  createComponent({
    props: {
      buttonTheme: {
        type: Object,
        value: () => {}
      }
    },
    computed: {
      // // 按钮文案
      BtnText() {
        return this.buttonTheme?.text ?? ''
      },
      // 按钮样式
      btnStyle() {
        return `background: ${this.buttonTheme?.backgroundColor}; color: ${this.buttonTheme?.textColor}`
      }
    },
    methods: {
      // 点击按钮
      clickBtn() {
        // 上报点击事件
        this.triggerEvent('receiveFallingCoupon')
      }
    }
  })
</script>

<style lang='stylus' scoped>
  .coupon-button-container
    position relative
    .coupon-button
      width 160px
      height 45px
      border-radius 25px
      font-size 18px
      font-weight 800
      line-height 45px
      text-align center
</style>

<script name='json'>
  module.exports = {
    usingComponents: {}
  }
</script>
